// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewMargin_modal-scroll__Xqdgz","container":"ViewMargin_container__At3Q8"};